"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var billing;
        (function (billing_1) {
            var index;
            (function (index_1) {
                class InitArgs {
                    constructor() {
                        this.userPrmYearRates = [];
                        this.userPrmMonthRates = [];
                        this.userStdYearRates = [];
                        this.userStdMonthRates = [];
                        this.userEdgeYearRates = [];
                        this.userEdgeMonthRates = [];
                        this.userProYearRates = [];
                        this.userProMonthRates = [];
                        this.userGFYearRates = [];
                        this.userGFMonthRates = [];
                        this.serviceYearRates = {};
                        this.serviceMonthRates = {};
                        this.isTranched = false;
                        this.minimumUsersToBill = 0;
                        this.isVendor = false;
                        this.billingIndex = appn.emptyString;
                        this.entityId = appn.emptyString;
                        this.currency = 'USD';
                        this.countryStates = {};
                    }
                }
                let _initArgs;
                let _formatter;
                function init(args) {
                    _initArgs = args;
                    _formatter = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: args.currency,
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    });
                    addEvents();
                    appn.ui.initCountryStateDropdown({
                        countrySelector: '#CurrentEntity_Country',
                        stateTextSelector: '#CurrentEntity_State',
                        stateSelectSelector: '#CurrentEntity_State_Select',
                        countryStates: args.countryStates
                    });
                    calcUsers();
                    calcAddons();
                    $('.buyInfo').hide();
                    $('.backToTry').hide();
                }
                index_1.init = init;
                function addEvents() {
                    $('#ForProvider_Id').change(function () {
                        appn.location.navTo(_initArgs.billingIndex, [
                            { name: 'forId', value: $('#ForProvider_Id').val() },
                            { name: 'entityId', value: _initArgs.entityId }
                        ]);
                    });
                    $('.row.users input').change(function () {
                        calcUsers();
                    });
                    $('.row.users select').change(function () {
                        calcUsers();
                    });
                    $('.card-body.tiers .buyLineQuantity').change(function () {
                        calcTiers();
                    });
                    $('.card-body.tiers select').change(function () {
                        calcTiers();
                    });
                    $('.row.addons .buyLineQuantity').change(function () {
                        calcAddons();
                    });
                    $('.row.addons select').change(function () {
                        calcAddons();
                    });
                    $('.btnTry').click(function (e) {
                        e.preventDefault();
                        const lineType = $(this).data('type');
                        const lineDesc = $(this).data('desc');
                        const trialDays = $(this).data('days') || 30;
                        $('form#appnForm').attr('novalidate', 'novalidate')
                            .validate().settings.ignore = '*';
                        appn.dialog.confirm({
                            modalColor: 'modal-info',
                            title: T('Start Trial'),
                            message: T('Start your {0} day trial now?', trialDays),
                            buttons: {
                                confirm: {
                                    label: '<span>' + T('OK') + '</span>',
                                    className: 'btn-success'
                                }
                            },
                            callback: function (result) {
                                if (result) {
                                    $('form#appnForm').append('<input type="hidden" name="TrialFor" value="' + lineType + '" />');
                                    $('form#appnForm').append('<input type="hidden" name="TrialForDesc" value="' + lineDesc + '" />');
                                    $('form#appnForm').submit();
                                }
                            }
                        });
                    });
                    $('.btnBuy').click(function (e) {
                        e.preventDefault();
                        const $lineContainer = $(this).closest('.billLine');
                        $lineContainer.find('.btnTry').hide();
                        $lineContainer.find('.btnBuy').hide();
                        $lineContainer.find('.trialInfo').hide();
                        $lineContainer.find('.tagLine').hide();
                        $lineContainer.find('.backToTry').show();
                        $lineContainer.find('.buyContainer').show();
                        $lineContainer.find('.buyInfo').show();
                        $lineContainer.find('.buyLineQuantity').val(1).trigger('change');
                        const $tiersParent = $lineContainer.parents('.tiers');
                        if ($tiersParent.length > 0) {
                            $tiersParent.find('.btnBuy').hide();
                            $tiersParent.find('.billLine').css('opacity', 0.5);
                            $tiersParent.find('.billLine .select2').css('visibility', 'collapse');
                            $lineContainer.css('opacity', 1);
                            $lineContainer.find('.billLine .select2').css('visibility', 'visible');
                        }
                    });
                    $('.backToTry').click(function (e) {
                        e.preventDefault();
                        const $lineContainer = $(this).closest('.billLine');
                        $lineContainer.find('.btnTry').show();
                        $lineContainer.find('.btnBuy').show();
                        $lineContainer.find('.trialInfo').show();
                        $lineContainer.find('.tagLine').show();
                        $lineContainer.find('.buyContainer').hide();
                        $lineContainer.find('.buyInfo').hide();
                        $(this).hide();
                        $lineContainer.find('.buyLineQuantity').val(0).trigger('change');
                        const $tiersParent = $lineContainer.parents('.tiers');
                        if ($tiersParent.length > 0) {
                            $tiersParent.find('.btnBuy').show();
                            $tiersParent.find('.billLine').css('opacity', 1);
                            $tiersParent.find('.billLine .select2').css('visibility', 'visible');
                        }
                    });
                    $('.buyLineQuantity').change(function (e) {
                        const $lineContainer = $(this).closest('.billLine');
                        const selected = $lineContainer.find('.buyLineQuantity').val() > 0;
                        $lineContainer.find('.btnRemove').toggle(selected);
                        $lineContainer.find('.btnActivate').toggle(!selected);
                    });
                    $('.btnRemove').click(function (e) {
                        e.preventDefault();
                        const $lineContainer = $(this).closest('.billLine');
                        appn.dialog.confirm({
                            modalColor: 'modal-danger',
                            className: 'appnGlobalConfirmDelete',
                            isDeleteAction: true,
                            title: T('Confirm Removal'),
                            message: T(`Are you sure you want to remove this subscription from your billing?
                              <br />
                              <br />
                              NOTE: Removal will be effective on your subscription's next renewal date.`),
                            buttons: {
                                confirm: {
                                    label: '<span>' + T('PROCEED') + '</span>',
                                    className: 'btn-success'
                                },
                                cancel: {
                                    label: T('CANCEL')
                                }
                            },
                            callback: function (result) {
                                if (result)
                                    $lineContainer.find('.buyLineQuantity').val(0).trigger('change');
                            }
                        });
                    });
                    $('.btnActivate').click(function (e) {
                        e.preventDefault();
                        $(this).closest('.billLine').find('.buyLineQuantity').val(1).trigger('change');
                    });
                }
                function calcUsers() {
                    $('.usersInfo').html(appn.emptyString);
                    if (_initArgs.userPrmMonthRates.length > 0) {
                        const userProBilling = new UserBilling(BillLineType.UserPro, _initArgs.userProMonthRates, _initArgs.userProYearRates, _initArgs.isTranched);
                        setCostPreview(userProBilling, 'users', T('Pro Users'), 'pro-users');
                        const userPrmBilling = new UserBilling(BillLineType.UserPrm, _initArgs.userPrmMonthRates, _initArgs.userPrmYearRates, _initArgs.isTranched);
                        setCostPreview(userPrmBilling, 'users', T('Premium Users'), 'prm-users');
                        const userStdBilling = new UserBilling(BillLineType.UserStd, _initArgs.userStdMonthRates, _initArgs.userStdYearRates, _initArgs.isTranched);
                        setCostPreview(userStdBilling, 'users', T('Standard Users'), 'std-users');
                        const userEdgeBilling = new UserBilling(BillLineType.UserEdge, _initArgs.userEdgeMonthRates, _initArgs.userEdgeYearRates, _initArgs.isTranched);
                        setCostPreview(userEdgeBilling, 'users', T('Edge Users'), 'edge-users');
                        if (_initArgs.minimumUsersToBill > 0 && (userPrmBilling.userCount + userStdBilling.userCount + userProBilling.userCount) < _initArgs.minimumUsersToBill)
                            $('.usersInfo').text(T('A minimum of {0} Pro/Premium/Standard user(s) is required', _initArgs.minimumUsersToBill));
                    }
                    else {
                        const userGFBilling = new UserBilling(BillLineType.UserGF, _initArgs.userGFMonthRates, _initArgs.userGFYearRates, _initArgs.isTranched);
                        setCostPreview(userGFBilling, 'users', T('Legacy Users'), 'gf-users');
                        if (_initArgs.minimumUsersToBill > 0 && userGFBilling.userCount < _initArgs.minimumUsersToBill)
                            $('.usersInfo').text(T('A minimum of {0} user(s) is required', _initArgs.minimumUsersToBill));
                    }
                }
                function calcTiers() {
                    setCostPreview(new ServiceBilling(BillLineType.DstlPrecision), 'tiers', T('Distill - Precision'), 'dstl-precision');
                    setCostPreview(new ServiceBilling(BillLineType.DstlVantage), 'tiers', T('Distill - Vantage'), 'dstl-vantage');
                    setCostPreview(new ServiceBilling(BillLineType.DstlSignature), 'tiers', T('Distill - Signature'), 'dstl-signature');
                    setCostPreview(new ServiceBilling(BillLineType.SyncFlow), 'tiers', T('Sync - Flow'), 'sync-flow');
                    setCostPreview(new ServiceBilling(BillLineType.SyncCascade), 'tiers', T('Sync - Cascade'), 'sync-cascade');
                    setCostPreview(new ServiceBilling(BillLineType.SyncSurge), 'tiers', T('Sync - Surge'), 'sync-surge');
                }
                function calcAddons() {
                    const webFormBilling = new ServiceBilling(BillLineType.WebForms);
                    setCostPreview(webFormBilling, 'add-ons', T('Web Forms'), 'webforms');
                    if (_initArgs.isVendor) {
                        const vendorBilling = new ServiceBilling(BillLineType.Vendor);
                        setCostPreview(vendorBilling, 'add-ons', T('Vendor Subscription'), 'vendor-sub');
                    }
                    else {
                        const entTkitBilling = new ServiceBilling(BillLineType.EntTkit);
                        setCostPreview(entTkitBilling, 'add-ons', T('Enterprise Toolkit'), 'ent-tkit');
                        const replicateBilling = new ServiceBilling(BillLineType.PlatformReplicate);
                        setCostPreview(replicateBilling, 'add-ons', T('Platform Replicate'), 'pfm-replicate');
                    }
                    const androidBilling = new ServiceBilling(BillLineType.AaaSAndroid);
                    setCostPreview(androidBilling, 'wlabel', `${T('App as a Service')} - Android`, 'aaas-android');
                    const iosBilling = new ServiceBilling(BillLineType.AaaSIOS);
                    setCostPreview(iosBilling, 'wlabel', `${T('App as a Service')} - iOS`, 'aaas-ios');
                    const windowsBilling = new ServiceBilling(BillLineType.AaaSWindows);
                    setCostPreview(windowsBilling, 'wlabel', `${T('App as a Service')} - Windows`, 'aaas-windows');
                    const waaSBilling = new ServiceBilling(BillLineType.WaaS);
                    setCostPreview(waaSBilling, 'wlabel', T('Web Portal as a Service'), 'waas');
                }
                let totals = {
                    month: {},
                    year: {}
                };
                function setCostPreview(billing, totalCls, description, cls) {
                    const $monthlyDiv = $('.costPreview .monthly .' + totalCls);
                    const $annualDiv = $('.costPreview .annually .' + totalCls);
                    $monthlyDiv.find('.' + cls).remove();
                    $annualDiv.find('.' + cls).remove();
                    totals.month[cls] = billing.monthTotal;
                    totals.year[cls] = billing.yearTotal;
                    if (billing.monthTotal > 0)
                        $monthlyDiv.append(`<div class="${cls}">${description} <span class="text-right">${_formatter.format(billing.monthTotal)}</span>`);
                    if (billing.yearTotal > 0)
                        $annualDiv.append(`<div class="${cls}">${description} <span class="text-right">${_formatter.format(billing.yearTotal)}</span>`);
                    const monthSum = Object.values(totals.month).reduce((acc, val) => acc + val, 0);
                    const yearSum = Object.values(totals.year).reduce((acc, val) => acc + val, 0);
                    const $cpMonth = $('.costPreview .monthly');
                    $cpMonth.find('.grand-total').html(`${_formatter.format(monthSum)}`);
                    if (monthSum > 0) {
                        $cpMonth.show();
                        $cpMonth.find('.still-deciding').hide();
                    }
                    else if (yearSum > 0)
                        $cpMonth.hide();
                    else {
                        $cpMonth.show();
                        $cpMonth.find('.still-deciding').show();
                    }
                    const $cpYear = $('.costPreview .annually');
                    $cpYear.find('.grand-total').html(`${_formatter.format(yearSum)}`);
                    if (yearSum > 0)
                        $cpYear.show();
                    else
                        $cpYear.hide();
                    const $divider = $('.costPreview .ma-divide');
                    if (yearSum > 0 && monthSum > 0)
                        $divider.show();
                    else
                        $divider.hide();
                }
                let BillLineType;
                (function (BillLineType) {
                    BillLineType[BillLineType["UserStd"] = 0] = "UserStd";
                    BillLineType[BillLineType["UserPrm"] = 1] = "UserPrm";
                    BillLineType[BillLineType["UserEdge"] = 2] = "UserEdge";
                    BillLineType[BillLineType["UserPro"] = 3] = "UserPro";
                    BillLineType[BillLineType["UserGF"] = 4] = "UserGF";
                    BillLineType[BillLineType["AaaSAndroid"] = 5] = "AaaSAndroid";
                    BillLineType[BillLineType["AaaSIOS"] = 6] = "AaaSIOS";
                    BillLineType[BillLineType["AaaSWindows"] = 7] = "AaaSWindows";
                    BillLineType[BillLineType["WaaS"] = 8] = "WaaS";
                    BillLineType[BillLineType["Server"] = 9] = "Server";
                    BillLineType[BillLineType["ServerManaged"] = 10] = "ServerManaged";
                    BillLineType[BillLineType["Publish"] = 11] = "Publish";
                    BillLineType[BillLineType["PlatformReplicate"] = 12] = "PlatformReplicate";
                    BillLineType[BillLineType["EntTkit"] = 13] = "EntTkit";
                    BillLineType[BillLineType["Vendor"] = 14] = "Vendor";
                    BillLineType[BillLineType["Support"] = 15] = "Support";
                    BillLineType[BillLineType["EdgeTx"] = 16] = "EdgeTx";
                    BillLineType[BillLineType["WebForms"] = 17] = "WebForms";
                    BillLineType[BillLineType["WebFormsTx"] = 18] = "WebFormsTx";
                    BillLineType[BillLineType["Other"] = 19] = "Other";
                    BillLineType[BillLineType["SyncFlow"] = 20] = "SyncFlow";
                    BillLineType[BillLineType["SyncCascade"] = 21] = "SyncCascade";
                    BillLineType[BillLineType["SyncSurge"] = 22] = "SyncSurge";
                    BillLineType[BillLineType["DstlPrecision"] = 23] = "DstlPrecision";
                    BillLineType[BillLineType["DstlVantage"] = 24] = "DstlVantage";
                    BillLineType[BillLineType["DstlSignature"] = 25] = "DstlSignature";
                })(BillLineType || (BillLineType = {}));
                class UserBilling {
                    constructor(billLineType, _monthRates, _yearRates, isTranched) {
                        this._monthRates = _monthRates;
                        this._yearRates = _yearRates;
                        this._type = BillLineType[billLineType];
                        this._isTranched = isTranched;
                    }
                    get monthTotal() {
                        if (this.freq === 'Month')
                            return this._isTranched ? this.calcTranchedTotal(this._monthRates) : this.calcBlockTotal(this._monthRates);
                        return 0;
                    }
                    get yearTotal() {
                        if (this.freq === 'Year')
                            return this._isTranched ? this.calcTranchedTotal(this._yearRates) : this.calcBlockTotal(this._yearRates);
                        return 0;
                    }
                    get userCount() {
                        var _a;
                        return (_a = Number($(`.${this._type} input`).val())) !== null && _a !== void 0 ? _a : 0;
                    }
                    get freq() {
                        return String($(`.${this._type} select`).val());
                    }
                    calcBlockTotal(rates) {
                        var _a;
                        const rate = rates.find(rate => this.userCount <= rate.key);
                        return ((_a = rate === null || rate === void 0 ? void 0 : rate.value) !== null && _a !== void 0 ? _a : 0) * this.userCount;
                    }
                    calcTranchedTotal(rates) {
                        let total = 0;
                        let runningUserTotal = 0;
                        $.each(rates, (index, rate) => {
                            if (this.userCount >= runningUserTotal + rate.key)
                                total += rate.key * rate.value;
                            else
                                total += ((this.userCount - runningUserTotal) > 0 ? this.userCount - runningUserTotal : 0) * rate.value;
                            runningUserTotal += rate.key;
                        });
                        if (rates.length > 0 && (this.userCount - runningUserTotal) > 0)
                            total += (this.userCount - runningUserTotal) * rates.slice(-1)[0].value;
                        return total;
                    }
                }
                class ServiceBilling {
                    constructor(billLineType, deviceOS) {
                        this._monthTotal = 0;
                        this._yearTotal = 0;
                        this._type = BillLineType[billLineType];
                        this._deviceOS = deviceOS !== null && deviceOS !== void 0 ? deviceOS : '';
                    }
                    get monthTotal() {
                        this.calcTotal();
                        return this._monthTotal;
                    }
                    get yearTotal() {
                        this.calcTotal();
                        return this._yearTotal;
                    }
                    calcTotal() {
                        this._monthTotal = 0;
                        this._yearTotal = 0;
                        const serviceBilling = this;
                        $(`.${this._type}${this._deviceOS ? "." + this._deviceOS : ""} .buyLineQuantity[value=1]`).each(function () {
                            const freq = $(this).closest('.billLine').find('select').val();
                            if (freq === 'Month')
                                serviceBilling._monthTotal += _initArgs.serviceMonthRates[serviceBilling._type];
                            else
                                serviceBilling._yearTotal += _initArgs.serviceYearRates[serviceBilling._type];
                        });
                    }
                }
            })(index = billing_1.index || (billing_1.index = {}));
        })(billing = views.billing || (views.billing = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
